import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { BeweLf } from '../../types/bewe-lf';
import { CommonModule } from '@angular/common';
import { ModalStore, SOFTLINE_FEATURE_MODAL, UiCoreModule } from '@softline/ui-core';
import { SOFTLINE_FEATURE_DELIVERY_NOTE } from '../../delivery-note.shared';
import * as DeliveryNoteStore from '../../stores/delivery-notes.store';
import { DefaultCommentDialogComponent } from '../../dialogs/default-comment-dialog/default-comment-dialog.component';
import {
  BeweOptionDialogComponent,
  BottomSheetOption,
} from '../../dialogs/bewe-option-dialog/bewe-option-dialog.component';
import { isDefinedNotEmpty, Store } from '@softline/core';
import { SerialNumberViewComponent } from '../serial-number-view/serial-number-view.component';
import { DeliveryNotesStore } from '../../stores/index';

@Component({
  selector: 'lib-delivery-note-material-card',
  imports: [CommonModule, UiCoreModule, SerialNumberViewComponent],
  templateUrl: './delivery-note-material-card.component.html',
  styleUrls: ['./delivery-note-material-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class DeliveryNoteMaterialCardComponent implements OnInit {
  @Input() idKopfLf = 0;
  @Input() deliveryMaterial: BeweLf | undefined;

  constructor(private store: Store) {}

  ngOnInit(): void {}

  async onChange(quantity: number): Promise<void> {
    if (!this.deliveryMaterial) return;

    await this.store.dispatch(
      SOFTLINE_FEATURE_DELIVERY_NOTE,
      DeliveryNoteStore.actions.preparePatchBewe,
      {
        id: this.idKopfLf,
        bewe: { ...this.deliveryMaterial, menge: quantity },
      }
    );
  }

  async onEditBeweClick(): Promise<void> {
    const result = await this.store.dispatch(
      SOFTLINE_FEATURE_MODAL,
      ModalStore.actions.open<
        { selected?: BottomSheetOption },
        { options: BottomSheetOption[]; itemName?: string }
      >(),
      {
        id: 'DELIVERY_NOTE_RETOUR_BOTTOM_SHEET',
        component: BeweOptionDialogComponent,
        data: {
          options: [{ id: 'ADD_VERMERK', label: 'Vermerk bearbeiten' }],
        },
        dismiss: {
          backdrop: true,
          escape: true,
          button: true,
        },
      }
    );
    if (result === 'DISMISSED') return;

    const vermerkResult = await this.store.dispatch(
      SOFTLINE_FEATURE_MODAL,
      ModalStore.actions.open<
        string | null,
        { vermerk?: string | null; isItem?: boolean }
      >(),
      {
        id: 'DELIVERY_NOTE_RETOUR_COMMENT',
        component: DefaultCommentDialogComponent,
        data: { vermerk: this.deliveryMaterial?.vermerk },
        dismiss: {
          backdrop: true,
          button: true,
          escape: false,
        },
      }
    );

    if (vermerkResult === 'DISMISSED' || vermerkResult === null) return;

    const bewe = { ...this.deliveryMaterial, vermerk: vermerkResult };
    await this.store.dispatch(
      SOFTLINE_FEATURE_DELIVERY_NOTE,
      DeliveryNoteStore.actions.preparePatchBewe,
      {
        id: this.idKopfLf,
        bewe,
      }
    );
  }

  patchBewe(id: number | string | undefined, seriennummer: BeweLf['seriennr']): void {
    const note = this.store.get(
      SOFTLINE_FEATURE_DELIVERY_NOTE,
      DeliveryNotesStore.getters.collection.entity,
      this.idKopfLf
    );

    const updatedBeweLfs = [...(note.bewelfs ?? [])];
    const index = updatedBeweLfs.findIndex((o) => o.id === id);

    if (index < 0) return;

    const beweLf = updatedBeweLfs[index];

    updatedBeweLfs.splice(index, 1, {
      ...beweLf,
      seriennr: seriennummer,
    });

    this.store.commit(
      SOFTLINE_FEATURE_DELIVERY_NOTE,
      DeliveryNotesStore.mutations.collection.prepare,
      {
        id: this.idKopfLf,
        action: 'patch',
        changes: {
          bewelfs: updatedBeweLfs,
        },
      }
    );
  }

  protected readonly isDefinedNotEmpty = isDefinedNotEmpty;
}
